export default __webpack_public_path__ + "assets/e8805a776b0543d2f312d0cbc61595f6.png";